
import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import DefaultScrollWithHeaderContent from "../../../../utils/DefaultScrollWithHeaderContent";
import MyTable from '../../../../utils/MyTable';

import { useDispatch, useSelector } from "react-redux";



//Import excel
import { forwardRef, useImperativeHandle } from "react";
import allActions from "../../../../../actions";
import { headerSearch, unoTheme } from "../../../../../assets/styles/unoTheme";
import { getDataToReturnsByAssetsReport } from "../../../../../controllers/ReportController";
import { applyMaskAmount, getFirstAndEndDateByMonthAndYear, getMonthAndYearPortfolioClosed, getMonthName, parseBrlCurrencyToFloat, parsePercentage } from "../../../../utils/utils";
import { TableFooter, Tooltip } from "@material-ui/core";

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tableColumn: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
    },
    hoverMonth: {
        cursor: "pointer",
        '&:hover': {
            color: unoTheme.greenMoney + " !important",
        }
    }
});

const SegregationTab = forwardRef((props, ref) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const clientOn = useSelector(state => state.clientOn)
    const [data, setData] = useState(null);
    const [groupBySegregation, setGroupBySegregation] = useState(null);
    const [totalsBySegregation, setTotalsBySegregation] = useState(null);
    const [totalConsolidatedByPeriod, setTotalConsolidatedByPeriod] = useState(null);

    const [month, setMonth] = useState(undefined);
    const [year, setYear] = useState(undefined);

    const [innerLoad, setInnerLoad] = useState({


        emptyMessage: "",
        loadMessage: "Carregando retornos globais...",
        size: "small"

    })

    async function loadData(client, month, year) {


        const { startDate, endDate } = getFirstAndEndDateByMonthAndYear(month, year);
        const { success, data } = await getDataToReturnsByAssetsReport(client, startDate, endDate, true, setInnerLoad, true);

        //console.log("data x: ", data);
        // const success = true;
        // const data = FileTest;
        // console.log("Data: ", data);
        if (success) {

            console.log("data: ", data);
            setInnerLoad(null)

            const grouped = { ...groupBySegregation }

            const { totalsInvestments: { month: tMonth, year1: tYear1, year2: tYear2, year3: tYear3 } } = data;
            const totalsBySegregation = {};
            const totalConsolidatedByPeriod = {
                month: tMonth,
                year1: tYear1,
                year2: tYear2,
                year3: tYear3,
                year1Performance: 0,
            }

            setGroupBySegregation(grouped)
            setTotalsBySegregation(totalsBySegregation)
            setTotalConsolidatedByPeriod(totalConsolidatedByPeriod)
            setData(data);

        } else {
            setInnerLoad(null);
        }

    }

    function makeReport() {
        const reportType = 'myReturnsBySegregation';

        const items = data.optionsSegregation.map((el) => {

            const key = el.value;
            const segregationLabel = el.name;
            return {
                segragationLabel: segregationLabel,
                monthPercent: data.monthSegregationRents[key],
                monthMoney: data.segregationBalanceMap.month[key] ? applyMaskAmount(data.segregationBalanceMap.month[key]) : "-",
                year1Percent: data.year1SegregationRents[key],
                year1Money: data.segregationBalanceMap.year1[key] ? applyMaskAmount(data.segregationBalanceMap.year1[key]) : "-",
                year2Percent: data.year2SegregationRents[key],
                year3Percent: data.year3SegregationRents[key],
            }

        })

        items.push({
            isTotalLine: true,
            segragationLabel: "CONSOLIDADO",
            monthPercent: "100%",
            monthMoney: applyMaskAmount(totalConsolidatedByPeriod.month, true),
            year1Percent: "100%",
            year1Money: applyMaskAmount(totalConsolidatedByPeriod.year1, true),
            year2Percent: "100%",
            year3Percent: "100%",
        })

        const reportData = {
            years: [...data?.years],
            items: items.filter(el => el != null), //removendo nulos
        };

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType,
            reportData: reportData,
            message: 'Gerando relatório...'
        }));
    }

    useImperativeHandle(ref, () => ({
        doPdfReport() {
            console.log("Do pdf");
            makeReport();
        }
    }));

    useEffect(() => {
        if (clientOn && clientOn.client && clientOn.client.id
            && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear) {

            const portfolioClosed = clientOn.client.portfolio_closed;
            const { month, year } = getMonthAndYearPortfolioClosed(portfolioClosed);
            setMonth(month)
            setYear(year)
            setData([]);
            loadData(clientOn.client, month, year);

        } else {
            setInnerLoad({
                emptyMessage: "Os retornos se dão a partir do lançamento de pelo menos um mês de carteira",
            })

        }

    }, [clientOn]);

    return (
        <div className={classes.root}>

            <DefaultScrollWithHeaderContent innerLoad={innerLoad}>
                {data != null && totalsBySegregation != null && data.monthSegregationRents != null ?
                    <MyTable
                        stickyHeader
                        size="small">
                        <colgroup>
                            <col width="20%" />
                            <col width="10%" />
                            <col width="15%" />
                            <col width="10%" />
                            <col width="15%" />
                            <col width="10%" />
                            <col width="10%" />
                        </colgroup>

                        <TableHead key={`head-segregation`}>
                            <TableRow key={`head1-segregation`} className="smallPadding mainColor">
                                <TableCell align="left">

                                </TableCell>

                                <TableCell
                                    className={classes.hoverMonth}
                                    onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                        path: "assetsByPeriodInReturns",
                                        data: {
                                            period: month ? getMonthName(month) + "/" + year : null,
                                            assets: data?.monthSubAssets,
                                        }
                                    }))} align="center" colSpan={2}>
                                    Mês
                                </TableCell>
                                <TableCell
                                    className={classes.hoverMonth}
                                    onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                        path: "assetsByPeriodInReturns",
                                        data: {
                                            period: data?.years?.[0],
                                            assets: data?.yearBefore1SubAssets,
                                        }
                                    }))} align="center" colSpan={2}>
                                    {data?.years?.[0]}
                                </TableCell>
                                <TableCell
                                    className={classes.hoverMonth}
                                    onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                        path: "assetsByPeriodInReturns",
                                        data: {
                                            period: data?.years?.[1],
                                            assets: data?.yearBefore2SubAssets,
                                        }
                                    }))}
                                    align="center" colSpan={1}>
                                    {data?.years?.[1]}
                                </TableCell>
                                <TableCell
                                    className={classes.hoverMonth}
                                    onClick={() => dispatch(allActions.rightContentActions.setRightContent({
                                        path: "assetsByPeriodInReturns",
                                        data: {
                                            period: data?.years?.[2],
                                            assets: data?.yearBefore1SubAssets,
                                        }
                                    }))}
                                    align="center" colSpan={1}>
                                    {data?.years?.[2]}
                                </TableCell>
                            </TableRow>
                            <TableRow key={`head2-segregation`} className="smallPadding grayColor">
                                <TableCell align="left">
                                    Segregação
                                </TableCell>
                                <TableCell align="center">
                                    %
                                </TableCell>
                                <TableCell align="right">
                                    R$
                                </TableCell>
                                <TableCell align="center">
                                    %
                                </TableCell>
                                <TableCell align="right">
                                    R$
                                </TableCell>
                                <TableCell align="center">
                                    %
                                </TableCell>
                                <TableCell align="center">
                                    %
                                </TableCell>

                            </TableRow>

                        </TableHead>

                        <TableBody>
                            {
                                data.optionsSegregation.map((el) => {
                                    // console.log("###", segregationLabel);
                                    // console.log("totalsBySegregation[key]: ", totalsBySegregation[key]);
                                    const key = el.value;
                                    const segregationLabel = el.name;
                                    return (
                                        <TableRow key={`row-segregation-${key}`}>
                                            <TableCell align="left">
                                                {segregationLabel}
                                            </TableCell>
                                            <TableCell align="center">
                                                {data.monthSegregationRents[key]}
                                            </TableCell>
                                            <TableCell align="right">
                                                {data.segregationBalanceMap.month[key] ? applyMaskAmount(data.segregationBalanceMap.month[key]) : "-"}
                                            </TableCell>
                                            <TableCell align="center">
                                                {data.year1SegregationRents[key]}
                                            </TableCell>
                                            <TableCell align="right">
                                                {data.segregationBalanceMap.year1[key] ? applyMaskAmount(data.segregationBalanceMap.year1[key]) : "-"}
                                            </TableCell>
                                            <TableCell align="center">
                                                {data.year2SegregationRents[key]}
                                            </TableCell>
                                            <TableCell align="center">
                                                {data.year3SegregationRents[key]}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }

                        </TableBody>

                        {
                            totalConsolidatedByPeriod && data?.monthSegregationRents ?
                                <TableFooter className={"grayColor"}>
                                    <TableRow className='grayColor'>
                                        <TableCell align="left">CONSOLIDADO</TableCell>
                                        <TableCell align="center">{data.monthSegregationRents[0]}</TableCell>
                                        <TableCell align="right">{applyMaskAmount(totalConsolidatedByPeriod.month)}</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="right">{applyMaskAmount(totalConsolidatedByPeriod.year1)}</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                        <TableCell align="center">100%</TableCell>
                                    </TableRow>
                                </TableFooter>
                                : null
                        }




                    </MyTable>
                    : null
                }
            </DefaultScrollWithHeaderContent>
        </div >
    );
})

export default SegregationTab;



